import React from "react";
import { Select, Row, Col, Typography, Card } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
const { Title, Text } = Typography;
export default function AnalyticsFilters({
  projects,
  selectedProject,
  onProjectChange,
  selectedUserFilter,
  onUserFilterChange,
}) {
  return (
      <Card
        style={{
          padding: "10px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          backgroundColor: "#042956",
          marginBottom: "24px",
          border: "none",
          width: "100%"
        }}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "16px"
        }}>
          <Title level={2} style={{
            margin: 0,
            color: "#ffffff",
            fontSize: "20px",
            fontWeight: 600
          }}>
            <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: "12px", opacity: 0.9 }} />
            Filtro de búsqueda
          </Title>
        </div>
        <div style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          alignItems: "center"
        }}>
          <div style={{ flex: "1 1 200px", minWidth: "200px" }}>
            <Select
              value={selectedProject}
              onChange={onProjectChange}
              style={{ width: "100%", marginTop: 8 }}
              placeholder="Todos los proyectos"
              options={[
                { label: "Todos los proyectos", value: "all" },
                ...projects.map((p) => ({
                  label: p,
                  value: p,
                })),
              ]}
            />
          </div>
          <div style={{ flex: "1 1 200px", minWidth: "200px" }}>
            <Select
              value={selectedUserFilter}
              onChange={onUserFilterChange}
              style={{ width: "100%", marginTop: 8 }}
              placeholder="Todos los archivos"
              options={[
                { label: "Todos los archivos", value: "all" },
                { label: "Con Usuario", value: "with-user" },
                { label: "Sin Usuario", value: "without-user" },
              ]}
            />
          </div>
        </div>
      </Card>
  );
}
